import axios from "axios";
import { StockEPSMomentum } from "@/models/stock-eps";

export const getStockEPSMomentum = async (stockId: number) => {
    const res = await axios.get<StockEPSMomentum>(`/API/v2/id/${stockId}/eps/momentum/`);

    return res.data;
};
